import { Services, regExp } from '@sigma-frontend-libs/commons'
import { Colors } from '@sigma-frontend-libs/commons'

import { components, icons, popperPlacements } from '@/utils'

import info from '@/components/info'
import selectorOwner from '@/components/selector/owner'
import ipWhitelist from '@/components/services/settings/smpp/ipWhitelist'
import sticker from '@/components/sticker'

function renderDescriptionField(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.description,
        label: this.getTranslate(`${Services.tokens}.labels.description`),
        hint: this.getTranslate(`${Services.tokens}.hints.description`),
        required: true,
        dense: true,
        rows: 2,
        grow: true,
        clearable: true,
        details: true,
        autofocus: true,
        mask: regExp.titleSoft
      },
      on: {
        input: event => {
          this.proxy.description = event
        }
      }
    }
  )
}

function renderOwnerField(h) {
  if (!this.OwnerId) {
    return h(
      selectorOwner,
      {
        props: {
          value: this.proxy.OwnerId,
          disabled: !this.isNew,
          dense: true
        },
        on: {
          input: event => {
            this.proxy.OwnerId = event
          }
        }
      }
    )
  }
}

function renderExpiredAt(h, asSlot) {
  let expiredAtOnClick
  let expiredAtSlot
  if (asSlot) {
    expiredAtOnClick = () => {}
    expiredAtSlot = 'activator'
  }

  return h(
    sticker,
    {
      props: {
        value: this.expiredAtTitle,
        label: this.getTranslate(`${Services.tokens}.labels.expiredAt`),
        icon: icons.event_busy,
        color: Colors.grey,
        iconTooltip: this.expiredAtTitle,
        onClick: expiredAtOnClick,
        width: '100%'
      },
      slot: expiredAtSlot
    }
  )
}
function renderDatePicker(h) {
  return h(
    components['date-picker'],
    {
      props: {
        value: this.proxy.expiredAt,
        localeTag: this.locale,
        range: false,
        min: this.dateRange.min,
        max: this.dateRange.max
      },
      on: {
        input: event => {
          this.proxy.expiredAt = event
        }
      }
    }
  )
}
function renderExpiredAtField(h) {
  if (this.isNew) {
    return h(
      components.menu,
      {
        props: {
          rounded: true,
          offsetDistance: 8,
          placement: popperPlacements['bottom-start'],
          closeOnContentClick: false
        }
      },
      [
        renderExpiredAt.call(this, h, true),
        renderDatePicker.call(this, h)
      ]
    )
  } else {
    return renderExpiredAt.call(this, h, false)
  }
}

function renderIpWhitelistField(h) {
  if (this.hasPermissions) {
    return h(
      ipWhitelist,
      {
        props: {
          value: this.proxy.ipWhitelist,
          complex: false
        },
        on: {
          input: event => {
            this.proxy.ipWhitelist = event
          }
        }
      }
    )
  } else {
    return h(
      info,
      {
        props: {
          value: this.getTranslate(`${Services.tokens}.hints.ipWhitelist`)
        }
      }
    )
  }
}

export default function(h) {
  return h(
    components.form,
    {
      class: `${Services.tokens}-form`
    },
    [
      renderDescriptionField.call(this, h),
      renderOwnerField.call(this, h),
      renderExpiredAtField.call(this, h),
      renderIpWhitelistField.call(this, h)
    ]
  )
}
